import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function preventFutureDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value || typeof control.value !== 'string') {
      return null;
    }

    const parts = control.value.split('.');
    if (parts.length !== 3) {
      return { invalidDateFormat: true };
    }

    const [day, month, year] = parts.map(Number);

    const selected = new Date(year, month - 1, day);
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    selected.setHours(0, 0, 0, 0);

    return selected > today ? { futureDateNotAllowed: true } : null;
  };
}
